import type { MarketplaceErrorRes } from '@dvb/common';

import { BaseErrorLayout } from '@dvb/ui';
import { HeaderBar } from '@school-manage/ui/HeaderBar/HeaderBar';
import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function NewsDetailError({
  error,
}: {
  error: Error | MarketplaceErrorRes;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { description, title } = useMemo(() => {
    if ('code' in error && error.code === 2001) {
      return {
        description: t('notFoundDes', { name: t('news') }),
        title: t('notFound', { name: t('news') }),
      };
    }
    return { description: '', title: '' };
  }, [error, t]);

  return (
    <>
      <HeaderBar
        backBtnHandler={() => navigate({ replace: true, to: '/news' })}
        hasBackBtn
        title={t('news')}
      />
      <BaseErrorLayout
        className="bg-background w-full"
        description={description}
        title={title}
      />
    </>
  );
}
